import { render, staticRenderFns } from "./RobberyComplaintNotFiledQuestion.vue?vue&type=template&id=17f8004b"
import script from "./RobberyComplaintNotFiledQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyComplaintNotFiledQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyComplaintNotFiledQuestion.vue?vue&type=style&index=0&id=17f8004b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports